import React from 'react';

const Logo = (props: any) => (
  <svg
    version="1.1"
    viewBox="0.0 0.0 300.0 300.0"
    fill="none"
    stroke="none"
    strokeLinecap="square"
    strokeMiterlimit="10"
    {...props}
  >
    <clipPath id="p.0">
      <path d="m0 0l300.0 0l0 300.0l-300.0 0l0 -300.0z" clipRule="nonzero" />
    </clipPath>
    <g clipPath="url(#p.0)">
      <path
        fill="#000000"
        fillOpacity="0.0"
        d="m0 0l300.0 0l0 300.0l-300.0 0z"
        fillRule="nonzero"
      />
      <path
        fill="#000000"
        d="m2.3622048 150.0l0 0c0 -81.5381 66.09969 -147.6378 147.6378 -147.6378l0 0c39.155975 0 76.70822 15.554652 104.39569 43.242107c27.687439 27.687458 43.242096 65.239716 43.242096 104.39569l0 0c0 81.5381 -66.099686 147.63779 -147.63779 147.63779l0 0c-81.5381 0 -147.6378 -66.099686 -147.6378 -147.63779z"
        fillRule="nonzero"
      />
      <path
        stroke="#000000"
        strokeWidth="1.0"
        strokeLinejoin="round"
        strokeLinecap="butt"
        d="m2.3622048 150.0l0 0c0 -81.5381 66.09969 -147.6378 147.6378 -147.6378l0 0c39.155975 0 76.70822 15.554652 104.39569 43.242107c27.687439 27.687458 43.242096 65.239716 43.242096 104.39569l0 0c0 81.5381 -66.099686 147.63779 -147.63779 147.63779l0 0c-81.5381 0 -147.6378 -66.099686 -147.6378 -147.63779z"
        fillRule="nonzero"
      />
      <path
        fill="#000000"
        fillOpacity="0.0"
        d="m2.3622048 2.3622048l295.27557 0l0 295.27557l-295.27557 0z"
        fillRule="nonzero"
      />
      <path
        fill="#28dc18"
        d="m41.203125 170.52594l17.15625 -1.5q1.21875 10.3125 5.671875 16.921875q4.453125 6.609375 13.828125 10.6875q9.375 4.078125 21.09375 4.078125q10.40625 0 18.375 -3.09375q7.96875 -3.09375 11.859375 -8.484375q3.8906097 -5.390625 3.8906097 -11.765625q0 -6.46875 -3.7499847 -11.296875q-3.75 -4.828125 -12.375 -8.109375q-5.53125 -2.15625 -24.46875 -6.703125q-18.9375 -4.546875 -26.53125 -8.578125q-9.84375 -5.15625 -14.671875 -12.796875q-4.828125 -7.6406174 -4.828125 -17.109367q0 -10.40625 5.90625 -19.453125q5.90625 -9.046875 17.25 -13.734375q11.34375 -4.6875 25.21875 -4.6875q15.28125 0 26.953125 4.921875q11.67186 4.921875 17.95311 14.484375q6.28125 9.5625 6.75 21.65625l-17.437485 1.3125q-1.40625 -13.03125 -9.515625 -19.6875q-8.109375 -6.65625 -23.953125 -6.65625q-16.5 0 -24.046875 6.046875q-7.546875 6.046875 -7.546875 14.578125q0 7.40625 5.34375 12.1875q5.25 4.7812424 27.421875 9.796867q22.171875 5.015625 30.421875 8.765625q11.999985 5.53125 17.718735 14.015625q5.71875 8.484375 5.71875 19.546875q0 10.96875 -6.28125 20.671875q-6.28125 9.703125 -18.04686 15.09375q-11.765625 5.390625 -26.484375 5.390625q-18.65625 0 -31.265625 -5.4375q-12.609375 -5.4375 -19.78125 -16.359375q-7.171875 -10.921875 -7.546875 -24.703125zm133.49998 44.15625l0 -137.4375l18.1875 0l0 121.21874l67.687515 0l0 16.21875l-85.875015 0z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Logo;
